import React, {useEffect, useState} from 'react';
import { useParams } from "react-router-dom";

import Prism from '../../prism-plugins-tomorrow'
import {withParams} from "../../App";
import {attachCopyTagHandlers} from "../../utility";
import PageComponent from "../pageComponent/pageComponent";
import $ from "jquery";

const slugs = [
    {slug:'getting-started-cli',
        source: '/ml/tutorials/mlnet/mlnet-getting-started-cli-test.html',
        title: 'Getting started from the Command Line',
        tags: ['ML', 'ML.NET'],
        algos: [''],
        languages: ['C#'],
        sourceLinks:[],
        attributed:'' },
    {slug:'getting-started-ide',
        source: '/ml/tutorials/mlnet/mlnet-getting-started-ide.html',
        title: 'Getting started using an IDE',
        tags: ['IDE'],
        algos: ['FastTree'], languages: ['C#'],
        dataFile: '/data/explore/titanic-train-data.csv?label=Survived',
        sourceLinks:['https://github.com/intelligeus/machine-learning-mlnet/tree/main/TitanicApp'], attributed:'' },
    {slug:'dotnet-interactive-notebook',
        source: '/ml/tutorials/mlnet/mlnet-dotnet-interactive-notebook.html',
        title: 'What are dotnet interactive notebooks',
        tags: ['Interactive'],
        algos: [], languages: ['C#'],
        dataFile: '',
        sourceLinks:[],
        attributed:'' },
    {slug:'dotnet-interactive-housing',
        source: '/ml/tutorials/mlnet/housing-example.html',
        title: 'House Price Prediction', tags: [], algos: [], languages: ['C#'], sourceLinks:[], attributed:'' },
    {slug:'interactive-iris-classification',
        source: '/ml/tutorials/mlnet/interactive/mlnet-interactive-iris-classification.html',
        title: 'Interactive Iris Classification',
        tags: ['Interactive', 'Classification', 'Clustering'],
        algos: ['MulticlassClassification', 'SdcaMaximumEntropyMulti'],
        languages: ['C#'],
        dataFile: '/data/explore/iris.csv?label=class', sourceLinks:['https://github.com/intelligeus/machine-learning-mlnet/tree/main/TitanicApp'], attributed:'',
        download: '/download/notebook/interactive-iris-classification.ipynb'
    },
    {slug:'mlnet-interactive-time-series',
        source: '/ml/tutorials/mlnet/interactive/mlnet-interactive-time-series.html',
        title: 'Interactive Stock Market Prediction tutorial',
        tags: ['Forecasting', 'Time Series'],
        algos: ['SSA'],
        languages: ['C#'],
        dataFile: '/data/explore/msft-train-data.csv?label=Adj Close', sourceLinks:[], attributed:'',
        download: '/download/notebook/interactive-stock-market-prediction.ipynb'},
    {slug:'mlnet-binary-image-classification',
        source: '/ml/tutorials/mlnet/mlnet-binary-image-classification.html',
        title: 'Basic Image Classification',
        tags: ['Classification', 'Images', 'Tensorflow'],
        algos: ['BinaryClassification', 'MulticlassClassification'],
        languages: ['C#'],
        dataFile: '', sourceLinks:['https://github.com/intelligeus/machine-learning-mlnet/tree/main/BinaryImageClassification'], attributed:''},
    {slug:'mlnet-titanic-binary-classification',
        source: '/ml/tutorials/mlnet/mlnet-titanic-binary-classification.html',
        title: 'Binary Classification Example',
        tags: ['Classification'],
        algos: ['FastTree', 'FastForest'],
        languages: ['C#'],
        dataFile: '/data/explore/titanic-train-data.csv?label=Survived', sourceLinks:['https://github.com/intelligeus/machine-learning-mlnet/tree/main/TitanicApp'], attributed:''},
    {slug:'mlnet-interactive-titanic-binary-classification',
        source: '/ml/tutorials/mlnet/interactive/mlnet-interactive-titanic-classification.html',
        title: 'Interactive Binary Classification',
        tags: ['Classification', 'Interactive'],
        algos: ['FastTree', 'FastForest'],
        languages: ['C#'],
        dataFile: '/data/explore/titanic-train-data.csv?label=Survived', sourceLinks:[], attributed:'',
        download: '/download/notebook/interactive-titanic-classification.ipynb'},
    {slug:'mlnet-multi-image-classification',
        source: '/ml/tutorials/mlnet/mlnet-multi-image-classification.html',
        title: 'Multi Image Classification',
        tags: ['Classification', 'Tensorflow'],
        algos: ['Softmax2'],
        languages: ['C#'],
        sourceLinks:['https://github.com/intelligeus/machine-learning-mlnet/tree/main/MultiImageClassification'], attributed:''},
    {slug:'mlnet-stock-price-prediction',
        source: '/ml/tutorials/mlnet/mlnet-stock-price-prediction.html',
        title: 'Stock price prediction (time series)',
        tags: ['Regression', 'Time series'],
        algos: ['SSA'],
        languages: ['C#'],
        dataFile: '/data/explore/msft-train-data.csv?label=Adj Close', sourceLinks:['https://github.com/intelligeus/machine-learning-mlnet/tree/main/StockMarketPrediction'], attributed:''},
    {slug:'mlnet-linear-regression',
        source: '/ml/tutorials/mlnet/mlnet-linear-regression-tutorial.html',
        title: 'Linear Regression Tutorial',
        tags: [],
        algos: ['SCDA'],
        languages: ['C#'],
        dataFile: '/data/explore/taxi-fare-train.csv?label=fare_amount', sourceLinks:['https://github.com/intelligeus/machine-learning-mlnet/tree/main/LinearRegression'], attributed:''},
    {slug:'mlnet-nlp-text-classification',
        source: '/ml/tutorials/mlnet/mlnet-nlp-basic-example.html',
        title: 'NLP Text Classification example',
        tags: ['NLP', 'Text Classification'],
        algos: ['NasBertTrainer'],
        languages: ['C#'],
        dataFile: '/data/explore/home-depot-train.csv?label=relevance', sourceLinks:['https://github.com/intelligeus/machine-learning-mlnet/tree/main/NLPExample'], attributed:''},
    {slug:'mlnet-nlp-senntence-similarity',
        source: '/ml/tutorials/mlnet/mlnet-nlp-sentence-similarity.html',
        title: 'Compare the similarity of sentences',
        tags: ['NLP', 'Text Classification'],
        algos: [''],
        languages: ['C#'],
        dataFile: '/data/explore/home-depot-train.csv?label=relevance', sourceLinks:['https://github.com/intelligeus/machine-learning-mlnet/tree/main/NLPSentences'], attributed:''},

];
const nextPage = [
    {key: 'getting-started-cli',
        slug: 'getting-started-ide',
        title: 'Getting stared with an IDE',
        path: '/machine-learning/tutorials/mlnet/'},
    {key: 'getting-started-ide',
        slug: 'dotnet-interactive-notebook',
        title:'Interactive Notebooks',
        path: '/machine-learning/tutorials/mlnet/' },
    {key: 'dotnet-interactive-notebook',
        slug: 'interactive-iris-classification',
        title:'Interactive Iris Classification',
        path: '/machine-learning/tutorials/mlnet/' },
    {key: 'interactive-iris-classification',
        slug: 'mlnet-titanic-binary-classification',
        title:'Binary Classification',
        path: '/machine-learning/tutorials/mlnet/' },
    {key: 'mlnet-titanic-binary-classification',
        slug: 'mlnet-interactive-titanic-binary-classification',
        title:'Interactive Binary Classification',
        path: '/machine-learning/tutorials/mlnet/' },
    {key: 'mlnet-interactive-titanic-binary-classification',
        slug: 'mlnet-binary-image-classification',
        title:'Image Classification',
        path: '/machine-learning/tutorials/mlnet/' },
    {key: 'mlnet-binary-image-classification',
        slug: 'mlnet-multi-image-classification',
        title:'Multi Image Classification',
        path: '/machine-learning/tutorials/mlnet/' },

    {key: 'mlnet-multi-image-classification',
        slug: 'mlnet-linear-regression',
        title:'Linear Regression',
        path: '/machine-learning/tutorials/mlnet/' },
    {key: 'mlnet-linear-regression',
        slug: 'mlnet-interactive-time-series',
        title:'Interactive Time Series',
        path: '/machine-learning/tutorials/mlnet/' },
    {key: 'mlnet-interactive-time-series',
        slug: 'mlnet-stock-price-prediction',
        title:'Stock Price Prediction',
        path: '/machine-learning/tutorials/mlnet/' },

    {key: 'mlnet-stock-price-prediction',
        slug: 'mlnet-nlp-text-classification',
        title: 'MLP Text Classification',
        path: '/machine-learning/tutorials/mlnet/' },


    {key: 'mlnet-nlp-text-classification',
        slug: 'mlnet-nlp-sentence-similarity',
        title: 'Sentence Similarity',
        path: '/machine-learning/tutorials/mlnet/' },
    {key: 'mlnet-nlp-sentence-similarity',
        slug: '',
        title: 'ML.NET Tutorials',
        path: '/machine-learning/tutorials/mlnet'}
]

const relatedPages = ['I am a page'];
const suggestedCourses = [];


export const MLNETPage = (props) => {

    const [slug, setSlug] = useState(useParams().slug);
    let state = {};


    // Get the contents from the HTML file and put them in the React state, so we can reference it in render() below.
    const path = slugs.filter(path => path.slug === slug);
    //console.log("MD Slug [" + slug + "] matched to url [" + path[0].source + "]")

    if (path.length === 0) {
        console.error('MLNET Failed to located HTML path for slug : ' + slug);
    }

    const next = nextPage.filter(item => item.key === slug)[0];
    const related = relatedPages.filter(item => item.key === slug);
    const suggested = suggestedCourses.filter(item => item.key === slug);

    state = {
        nextContent: next,
        relatedContent: related,
        source: path[0].source,
        title: path[0].title,
        tags: path[0].tags,
        sourceLinks: path[0].sourceLinks,
        languages: path[0].languages,
        algos: path[0].algos,
        suggestedCourses: suggested,
        html: "",
        attributed: path[0].attributed,
        dataFile: path[0].dataFile,
        download: path[0].download
    };

    return (
        <PageComponent props={state} page="MLNET Page"/>
    );

}
